import mixpanel, { Dict } from 'mixpanel-browser';
import isEqual from 'lodash/isEqual';
import { Mixpanel } from '@interfaces';
import { Buffer } from 'buffer';
import { getNodeEnv, getMixpanelToken, getMixpanelHost } from './environment';

const nodeEnv = getNodeEnv();
const mixpanelToken = getMixpanelToken();
const mixpanelHost = getMixpanelHost();

export function initMixpanel(deviceId: string) {
  let inspiredMixpanel: Mixpanel | null = null;

  if (mixpanelToken) {
    mixpanel.init(mixpanelToken, {
      api_host: mixpanelHost,
      debug: nodeEnv === 'development' || nodeEnv === 'stage',
      cross_subdomain_cookie: false,
      secure_cookie: true,
      ignore_dnt: true
    });

    inspiredMixpanel = {
      track: (eventName: string, props: Dict = {}, deduplicationId?: string | number) => {
        if (nodeEnv === 'test') return;
        const adminPreview = (window as any).adminPreview;
        if (adminPreview) return;
        if (typeof document === 'undefined') return;
        if (deduplicationId) {
          let existingEvents: string[] = [];
          const newEvent = Buffer.from(
            encodeURIComponent(
              JSON.stringify([eventName, `${deduplicationId}`, JSON.stringify(props)])
            )
          ).toString('base64');
          const eventData = sessionStorage.getItem('__inspired_events__');
          if (eventData) existingEvents = JSON.parse(eventData);
          const match = existingEvents.find(event => isEqual(event, newEvent));
          if (!match) {
            existingEvents.push(newEvent);
            sessionStorage.setItem('__inspired_events__', JSON.stringify(existingEvents));
            mixpanel?.track(eventName, { ...props, ...{ distinct_id: deviceId } });
          }
        } else {
          mixpanel?.track(eventName, { ...props, ...{ distinct_id: deviceId } });
        }
      },
      setStoreProperties: (storeId: string, storeName: string, props: Dict) => {
        if (typeof document === 'undefined') return;
        mixpanel.get_group('platformStoreId', storeId).set({ ...props, $name: storeName });
      },
    };
  }

  return inspiredMixpanel;
}
